import type { PluralizationRule } from 'vue-i18n'
import type { Locale } from '@/router/locales'

function twoFormPlural(choice: number, choicesLength: number) {
  if (choicesLength <= 1) return 0
  if (choicesLength === 2) return choice === 1 ? 0 : 1

  if (choice === 0) return 0
  if (choice === 1) return 1
  return 2
}

export const pluralRules = {
  no: twoFormPlural,
  en: twoFormPlural,
} satisfies Record<Locale, PluralizationRule>
